import Logo from './Logo';

export default function SiteFooter() {
  return (
    <footer className="footer">
      <div className="container footer__inner">
        <Logo height={24} />
        <span className="footer__meta">Registered in England · Great Britain · © 2026</span>
      </div>
    </footer>
  );
}
